module.exports = __webpack_public_path__ + "static/media/21ECLAC47.fbf5a1d7.jpg";